// Arabic (RTL) — mirrors src/i18n/local/en/common.ts for buyers in the Gulf / MENA.
// The UI flips to RTL automatically via applyDocumentDirection().
// Font preference: Tajawal or Cairo (defined in src/index.css).

const common = {
  "nav.home": "الرئيسية",
  "nav.products": "المنتجات",
  "nav.factory": "المصنع",
  "nav.about": "نبذة عنّا",
  "nav.contact": "تواصل معنا",
  "nav.requestQuote": "طلب عرض سعر",
  "nav.menu": "القائمة",
  "nav.language": "اللغة",

  "cta.requestQuote": "اطلب عرض سعر",
  "cta.exploreCatalog": "تصفح الكتالوج",
  "cta.contactUs": "اتصل بنا",
  "cta.scheduleFactoryVisit": "احجز زيارة المصنع",
  "cta.requestSample": "اطلب عينة",
  "cta.viewAll": "عرض كل المنتجات",

  "common.tbd": "[قيد التأكيد من Forwaro]",
  "common.category": "الفئة",
  "common.material": "المادة",
  "common.style": "النمط",
  "common.filters": "عوامل التصفية",
  "common.resetAll": "إعادة ضبط",
  "common.details": "التفاصيل",

  "brand.name": "Forwaro Furniture",
  "brand.chineseName": "風華國際",
  "brand.tagline": "FORWARO FURNITURE · 風華國際 · 現代傢俱",
  "whatsapp.cta": "راسلنا على واتساب",
  "wechat.cta": "أضِفنا على وي تشات",

  "home.hero.badge": "FORWARO · 風華國際 · 現代傢俱",
  "home.hero.headline.line1": "البيت هو",
  "home.hero.headline.line2Highlight": "مركز كل شيء",
  "home.hero.headline.line3": "في زحمة الحياة.",
  "home.hero.subheadline": "تُعد Forwaro Furniture (風華國際) شركة تصنيع OEM / ODM مقرها Dongguan، تجمع بين تصميم الأثاث وجودة إنتاج ثابتة لخدمة المستوردين في الشرق الأوسط وأوروبا والأمريكتين وآسيا.",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "خطوط المنتجات",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "إنتاج مفصَّل حسب الطلب",
  "home.hero.stat3.value": "دونغقوان",
  "home.hero.stat3.label": "منطقة مين تيان الصناعية",
  "home.hero.stat4.value": "عالمي",
  "home.hero.stat4.label": "شراكات تصدير جاهزة",
  "home.hero.scroll": "مرّر للأسفل",

  "home.categories.kicker": "تشكيلة منتجاتنا",
  "home.categories.heading": "ستة خطوط منتجات، ومصنع واحد جدير بالثقة",
  "home.categories.description": "طاولات طعام، وطاولات قهوة، وطاولات كونسول، وكراسي، وأرائك، وخزائن تلفزيون: خطوط الأثاث الستة B2B التي تنتجها Forwaro للتصدير.",

  "home.about.kicker": "عن Forwaro",
  "home.about.heading.line1": "تصميم أثاث",
  "home.about.heading.line2": "بجودة حِرَفية ثابتة.",
  "home.about.philosophy.en":
    "البيت مركز كل شيء في خضم حياة مزدحمة، حيث تصبح جمالية العيش ذوقاً ومسعى للناجحين. تدعم Forwaro Furniture اتساق التصميم وجودة الإنتاج، ليلتقي الجمال والإتقان في كل منزل.",
  "home.about.location": "تأسست Forwaro Furniture (風華國際有限公司) في Taiwan عام 1991، وتُصنّع منتجاتها في البر الرئيسي للصين منذ عام 2006، وتعمل اليوم من Min Tian Industrial Zone في Shatian Town بمدينة Dongguan. تتعاون Forwaro مع المستوردين الذين يقدّرون الحِرفية الصادقة والتسليم الموثوق.",
  "home.about.highlight1.title": "OEM و ODM",
  "home.about.highlight1.body":
    "إنتاج مخصص — من العلامة الخاصة إلى مشاريع التصميم والهندسة الكاملة.",
  "home.about.highlight2.title": "ضبط جودة تصديري",
  "home.about.highlight2.body":
    "تفتيش في كل مرحلة: النجارة، التنجيد، الدهان، التعبئة للشحن البحري.",
  "home.about.highlight3.title": "الرخام الطبيعي والفولاذ",
  "home.about.highlight3.body": "أسطح مميزة من الرخام الطبيعي، مقترنة بقواعد من الفولاذ المقاوم للصدأ المطلي كهربائيًا والحديد.",
  "home.about.highlight4.title": "تغطية عالمية",
  "home.about.highlight4.body": "نخدم المستوردين في الشرق الأوسط وأوروبا والأمريكتين وآسيا انطلاقًا من Dongguan.",
  "home.about.badgeLocation": "دونغقوان، الصين",
  "home.about.badgeZone": "منطقة مين تيان الصناعية",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "مخصص وعلامة خاصة",

  "home.featured.kicker": "لمحة عن الكتالوج",
  "home.featured.heading": "نظرة مسبقة على خطوط Forwaro الستة",
  "home.featured.description": "أكواد طُرز Forwaro الأصلية بمواد وأبعاد مؤكدة. تواصلوا معنا للحصول على المواصفات الكاملة وعرض السعر.",


  "home.markets.kicker": "تغطية عالمية",
  "home.markets.heading": "أسواق التصدير التي نخدمها",
  "home.markets.description":
    "تتعاون Forwaro مع مستوردي الأثاث والموزعين والمجموعات الفندقية والمشاريع السكنية في أربع قارات.",

  "home.process.heading": "كيف نعمل معكم",
  "home.process.description":
    "من الاستفسار الأول إلى تحميل الحاوية — تدفق التصدير القياسي لدى Forwaro.",

  "footer.getInTouch.kicker": "تواصل معنا",
  "footer.getInTouch.heading":
    "ابدأ رحلة استيراد الأثاث\nمع Forwaro",
  "footer.getInTouch.description":
    "يقدّم فريق التصدير لدينا عروض أسعار مخصصة، عينات، ووثائق تصدير كاملة لسوقك.",
  "footer.contact.email": "البريد الإلكتروني",
  "footer.contact.phone": "الهاتف",
  "footer.contact.fax": "الفاكس",
  "footer.contact.factory": "المصنع",
  "footer.contact.whatsappNote":
    "قنوات واتساب ووي تشات — بانتظار تأكيد Forwaro.",
  "footer.form.heading": "اطلب عرض سعر",
  "footer.form.name": "الاسم الكامل",
  "footer.form.email": "البريد الإلكتروني",
  "footer.form.company": "الشركة",
  "footer.form.country": "الدولة",
  "footer.form.countryPlaceholder": "اختر الدولة",
  "footer.form.message": "الرسالة",
  "footer.form.messagePlaceholder":
    "أخبرنا بمتطلباتك والكميات والسوق المستهدف…",
  "footer.form.submit": "أرسل الاستفسار",
  "footer.form.sending": "جارٍ الإرسال…",
  "footer.form.success.heading": "تم الإرسال!",
  "footer.form.success.body":
    "سيردّ فريق التصدير خلال يومَي عمل.",
  "footer.form.sendAnother": "أرسل رسالة أخرى",
  "footer.footerTagline": "Forwaro Furniture · 風華國際 · 現代傢俱. شركة تصنيع OEM/ODM مقرها Dongguan، تخدم المستوردين في الشرق الأوسط وأوروبا والأمريكتين وآسيا.",
  "footer.col.products": "المنتجات",
  "footer.col.company": "الشركة",
  "footer.col.markets": "أسواق التصدير",
  "footer.col.regional": "تبحث عن ممثّل إقليمي؟",
  "footer.copyright": "جميع الحقوق محفوظة.",
};

export default common;
